import MasterPhoneNumberIndex from "@/components/whatsapp/master_phone_number/MasterPhoneNumberIndex.vue";
import MasterPhoneNumberAdd from "@/components/whatsapp/master_phone_number/MasterPhoneNumberIndexAdd.vue";
import MasterPhoneNumberDetail from "@/components/whatsapp/master_phone_number/MasterPhoneNumberIndexDetail.vue";
import MasterPhoneNumberEdit from "@/components/whatsapp/master_phone_number/MasterPhoneNumberIndexEdit.vue";

let routesWaMasterPhoneNumber= [
    {
        path: '',
        meta: {
          title: "List Master Phone Number Access",
        },
        name: "MasterPhoneNumberIndex",
        component: MasterPhoneNumberIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Master Phone Number Access",
        },
        name: "MasterPhoneNumberAdd",
        component: MasterPhoneNumberAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Master Phone Number Access",
        },
        name: "MasterPhoneNumberDetail",
        component: MasterPhoneNumberDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Master Phone Number Access",
        },
        name: "MasterPhoneNumberEdit",
        component: MasterPhoneNumberEdit
    }
    
];

export default routesWaMasterPhoneNumber
  